export const BOOKING_FORM_ID = "book";

export const BOOKING_FORM_HREF = `#${BOOKING_FORM_ID}`;
